export const BLUE = '#0175FD'
export const BLUE_DARK = '#050567'
export const BLUE_ALT = '#5FECFD'

export const GREEN = '#8DD615'
export const GREEN_ALT = '#D9FE0E'

export const ORANGE = '#ffcc00'

export const RED = '#FF0000'

export const BLACK = '#2D2D2D'
export const BLACK_80 = 'rgba(0, 0, 0, 0.8)'
export const BLACK_75 = 'rgba(0, 0, 0, 0.75)'
export const BLACK_50 = 'rgba(0, 0, 0, 0.5)'
export const BLACK_20 = 'rgba(0, 0, 0, 0.2)'

export const WHITE = '#FFFFFF'

export const GREY = '#D1D3D4'
export const GREY_LIGHT = '#ECECEC'
export const GREY_DARK = '#858585'
export const GREY_DARKER = '#5F5F5F'
export const GREY_DARKEST = '#2D2D2D'

export const TRANSPARENT = '#rgba(0, 0, 0, 0)'

export const SKY_BLUE_50 = 'rgba(95, 236, 253, 0.5)'
export const LIGHT_BLUE_50 = 'rgba(19, 188, 255, 0.5)'
